module.exports = __webpack_public_path__ + "img/bank_icon3.64a41767.png";